import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar } from '../Home/components/Navbar';
import { Footer } from '../Home/components/Footer';
import { CategoryCard } from '../../components/shared/CategoryCard/CategoryCard';
import { SEO } from '../../components/SEO/SEO';
import { BASE_URL } from '../../config/config';
import './Categories.css';

export const Categories = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${BASE_URL}/services/get-all?page=1&limit=20`);
        const data = await response.json();
        
        if (!response.ok) {
          throw new Error(data.message || 'Failed to fetch categories');
        }
        
        setCategories(data.result || []);
        setError(null);
      } catch (err) {
        console.error('Error fetching categories:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
    window.scrollTo(0, 0);
  }, []);

  const handleCategoryClick = (categoryId) => {
    navigate(`/listing/${categoryId}`);
  };

  return (
    <>
      <SEO 
        title="Browse Event Categories | Hobi Hub - Find Activities & Experiences"
        description="Explore all event categories on Hobi Hub. From workshops and art classes to adventure activities and wellness retreats - find experiences that match your interests."
        keywords="event categories, workshops, activities, classes, experiences, hobbies, adventure, wellness, art, music, Hobi Hub"
        canonicalUrl="https://hobi.co.in/categories"
      />
      <div className="hero-bg" style={{ position: "relative" }}>
        <Navbar dark={false} />
        
        {/* Hero Section */}
        <div className="categories-hero">
          <div className="categories-hero-content">
            <h1 className="categories-title">Explore Categories</h1>
            <p className="categories-subtitle">
              Discover experiences that match your passions and interests
            </p>
          </div>
        </div>

        {/* Categories Grid */}
        <div className="categories-container">
          {loading ? (
            <div className="categories-loading">
              <div className="loading-spinner"></div>
              <p>Loading categories...</p>
            </div>
          ) : error ? (
            <div className="categories-error">
              <p>{error}</p>
            </div>
          ) : (
            <div className="categories-grid">
              {categories.map((category) => (
                <CategoryCard 
                  key={category._id}
                  category={category}
                  onClick={handleCategoryClick}
                />
              ))}
            </div>
          )}
        </div>

        <div className="categories-bottom-decor">
          <img
            src="/images/bg-edited.svg"
            loading="lazy"
            alt=""
          />
        </div>
      </div>
      <Footer />
    </>
  );
};
